'use client'

import { ErrorBoundary } from '@rollbar/react'

function ErrorFallback({ resetError }: { resetError: () => void }) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4">
      <h2 className="text-xl font-semibold">Something went wrong</h2>
      <button
        type="button"
        onClick={resetError}
        className="rounded bg-primary px-4 py-2 text-sm text-primary-foreground"
      >
        Try again
      </button>
    </div>
  )
}

export function DashboardErrorBoundary({ children }: { children: React.ReactNode }) {
  return <ErrorBoundary fallbackUI={ErrorFallback}>{children}</ErrorBoundary>
}
